import React, { useEffect, useState } from 'react';
import './style.css';
import Header from './components/Header';
import Nav from './components/Nav';
import Popover from './components/Popover';
import WorldMap from './components/WorldMap';
import data from './datas/sonepar-map.json';
import Europe from './components/Europe';
import {LangContext, CatsFilterContext, CurrentPointContext} from './components/AppContext';


function App() {

  const {points, categories, countries} = data;
  const [lang, setLang] = useState('fr');
  const [currentMap, setCurrentMap] = useState('World');
  const [worldCountries, setWorldCountries] = useState([]);
  const [europeCountries, setEuropeCountries] = useState([]);
  const [currentPoint, setCurrentPoint] = useState(null);
  const [currentCountry, setCurrentCountry] = useState(null);
  const [catsFilter, setCatsFilter] = useState([]);
  const [timer, setTimer] = useState(null);

  const selectMap = (map) => {
    setCurrentMap(map);
    setCurrentPoint(null);
  };

  const getCountry = (id) => {
    return countries.find(c => c.id === id);
  };

  const getCategory = (id) => {
    return categories.find(c => c.id === id);
  };

  const toggleCategory = (catId) => {
    let newFilter = [...catsFilter];    
    let index = newFilter.indexOf(catId);
    if (index === -1) newFilter.push(catId);
    else newFilter.splice(index, 1);
    setCatsFilter(newFilter);
    setCurrentPoint(null);
  };
  
  const resetApp = () => {
    setCatsFilter([]);
    setCurrentPoint(null);
    setCurrentMap('world');
  };

  const resetTimer = () => {
    clearTimeout(timer);
    setTimer(setTimeout(resetApp, 45000));
  };

  useEffect(() => {
    const countriesWithPoints = data.countries.map(country => {
      country.points = points.filter(point => point.country === country.id).map(point => {
          let coords = point.coords_pin.split(';');
          point.coords = {
            x:Number(coords[0]) - 16,
            y:Number(coords[1]) - 19
          };
          point.cat = getCategory(point.category);
          return point;
      });
      let xs = country.points.reduce((ary, point) => {ary.push(point.coords.x); return ary;}, []);
      let ys = country.points.reduce((ary, point) => {ary.push(point.coords.y); return ary;}, []);
      country.minX = Math.min(...xs);
      country.maxX = Math.max(...xs);
      country.minY = Math.min(...ys);
      country.maxY = Math.max(...ys);
      return country;
    });

    setWorldCountries(countriesWithPoints.filter(country => country.points.findIndex(point => point.map === 'World') !== -1));
    setEuropeCountries(countriesWithPoints.filter(country => country.points.findIndex(point => point.map === 'Europe') !== -1));

  }, []);

  useEffect(() => {
    setCurrentCountry(currentPoint ? getCountry(currentPoint.country) : null);
  }, [currentPoint]);

  return (
    <LangContext.Provider value={{lang, setLang}}>
      <CatsFilterContext.Provider value={{catsFilter, setCatsFilter}}>
        <CurrentPointContext.Provider value={{currentPoint, setCurrentPoint}}>
          <Header onSelectLang={setLang} onClick={resetTimer}/>
          <Nav categories={categories} toggleCategory={toggleCategory} onClick={resetTimer}/>
          <div id="scene" className="w-full relative" onClick={resetTimer}>
          <main className={`main relative ${currentMap === 'Europe' ? 'europe' : 'world'}`}>
            {
              currentMap === 'Europe' ?
              <Europe countries={europeCountries} selectWorld={() => selectMap('World')}/> :
              <WorldMap countries={worldCountries} selectEurope={() => selectMap('Europe')}/>
            }



            <Popover point={currentPoint} country={currentCountry} onClose={() => setCurrentPoint(null)} />

          </main>
          </div>
          <footer className={'text-gray-500'}>
              {
                lang === 'fr' ?
                'Ceci est une sélection parmi les 230 initiatives de développement durable dans lesquelles le groupe Sonepar est engagé' :
                'This is a selection of the approximately 230 sustainability initiatives in which Sonepar is currently engaged.'
              }

          </footer>

        </CurrentPointContext.Provider>
      </CatsFilterContext.Provider>
    </LangContext.Provider>
  );
}

export default App;
